import type { UserDetails } from '@/api/types/Common'

export const getUserLocation = (userDetails: UserDetails): string => {
  const { city, state } = userDetails
  if (city && state) {
    return `${city}, ${state}`
  } else if (city) {
    return city
  } else if (state) {
    return state
  } else {
    return 'Unknown location'
  }
}
